// GoalsRailSection.jsx — what the right rail shows while the Goal tab is open:
// words written today against the nearest word goal's daily pace, and the
// upcoming deadlines. Completed and cancelled goals have no deadline left, so
// they are not listed; a goal past due and still open is, with how late it is.
import React, { useState } from 'react';
import { deadlines, goalStatus, paceOf, progressOf, isOpen, byDue, fmtRate } from './goalModel';

const SHOWN = 4;

export default function GoalsRailSection({ goals, writing, live, onOpen }) {
  const [all, setAll] = useState(false);
  const list = deadlines(goals);
  const visible = all ? list : list.slice(0, SHOWN);

  const wordGoal = goals.filter((g) => g.metric === 'words' && isOpen(g)).sort(byDue)[0];
  const need = wordGoal ? Math.ceil(paceOf(wordGoal, progressOf(wordGoal, live))?.perDay || 0) : 0;
  const todayWords = writing?.today || 0;

  return (
    <>
      <p className="gr-label">Today</p>
      <div className="gr-today">
        <div className="gr-big">{todayWords.toLocaleString()} <span>words</span></div>
        <small>
          {wordGoal
            ? `Target ${fmtRate(need)}/day for “${wordGoal.name}”`
            : 'No active word goal'}
        </small>
        <div className="gr-prog"><i style={{ width: `${need ? Math.min(100, (todayWords / need) * 100) : 0}%` }} /></div>
      </div>

      <p className="gr-label">Upcoming deadlines</p>
      {list.length === 0 && <p className="gr-note">Nothing due.</p>}
      {visible.map(({ goal, days }) => (
        <button key={goal._id} type="button" className="gr-dl" onClick={() => onOpen(goal._id)}>
          <span className="gr-dl-t">{goal.name}</span>
          <span className={`gr-dd${days < 0 ? ' is-late' : days <= 7 ? ' is-soon' : ''}`}>
            {days < 0 ? `${-days}d late` : days === 0 ? 'today' : `${days}d`}
          </span>
        </button>
      ))}
      {list.length > SHOWN && (
        <button type="button" className="gr-more" onClick={() => setAll((v) => !v)}>
          {all ? 'Show less' : `Show all (${list.length})`}
        </button>
      )}
      {/* Kept for the screen-reader count of what is overdue at a glance. */}
      <span className="gv-sr">
        {list.filter(({ goal }) => goalStatus(goal, live) === 'overdue').length} overdue
      </span>
    </>
  );
}
